/* tslint:disable */
/* eslint-disable */
/**
 * Payment Schedule API
 * API to manage payment schedules (échéances de paiement)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Résultat de la génération d'une remise HBS. Le fichier se télécharge via GET /api/backoffice/prelevements/hbs/remises/{generationId}/csv. Une remise est toujours tracée, même à 0 contrat (pas de download dans ce cas).
 * 
 * @export
 * @interface GenerateHbsRemiseResponse
 */
export interface GenerateHbsRemiseResponse {
    /**
     * Identifiant de la remise générée (sert au download / à la confirmation)
     * @type {string}
     * @memberof GenerateHbsRemiseResponse
     */
    generationId: string;
    /**
     * Nom du fichier généré, ex. "prelevements-hbs-20260705.csv" (préfixé NE-PAS-UPLOADER-{ENV} hors production)
     * 
     * @type {string}
     * @memberof GenerateHbsRemiseResponse
     */
    fileName: string;
    /**
     * Nombre de contrats inclus (0 = aucune affaire nouvelle, remise tracée sans contrat)
     * @type {number}
     * @memberof GenerateHbsRemiseResponse
     */
    contractsCount: number;
    /**
     * Date de génération (ISO datetime)
     * @type {string}
     * @memberof GenerateHbsRemiseResponse
     */
    generationDate: string;
}

/**
 * Check if a given object implements the GenerateHbsRemiseResponse interface.
 */
export function instanceOfGenerateHbsRemiseResponse(value: object): value is GenerateHbsRemiseResponse {
    if (!('generationId' in value) || value['generationId'] === undefined) return false;
    if (!('fileName' in value) || value['fileName'] === undefined) return false;
    if (!('contractsCount' in value) || value['contractsCount'] === undefined) return false;
    if (!('generationDate' in value) || value['generationDate'] === undefined) return false;
    return true;
}

export function GenerateHbsRemiseResponseFromJSON(json: any): GenerateHbsRemiseResponse {
    return GenerateHbsRemiseResponseFromJSONTyped(json, false);
}

export function GenerateHbsRemiseResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GenerateHbsRemiseResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'generationId': json['generationId'],
        'fileName': json['fileName'],
        'contractsCount': json['contractsCount'],
        'generationDate': json['generationDate'],
    };
}

export function GenerateHbsRemiseResponseToJSON(json: any): GenerateHbsRemiseResponse {
    return GenerateHbsRemiseResponseToJSONTyped(json, false);
}

export function GenerateHbsRemiseResponseToJSONTyped(value?: GenerateHbsRemiseResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'generationId': value['generationId'],
        'fileName': value['fileName'],
        'contractsCount': value['contractsCount'],
        'generationDate': value['generationDate'],
    };
}

